import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import { setTime, wait } from 'Src/me/pages/guest/proposals/new/utils';
import type { BaseAnswerType } from '../../../../../../../chat/views/types';
import type { RadioLikeButtonGroupWithImagePropsType } from '../..';
import { simpleButtonStyle, simpleButtonHoverStyle, simpleButtonActiveStyle, simpleButtonAnsweredStyle } from '../../../SimpleButtonGroup/components/SimpleButton';
import { Balloon } from '../Balloon';

const { tablet, mobile } = mediaQueries();

type OtherButtonPropsType = Merge<RadioLikeButtonGroupWithImagePropsType & Required<BaseAnswerType> & {
  balloonContents?: React.ReactNode;
  isAnswered: boolean;
  onClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
}>;

export const OtherButton = ({
  id,
  value,
  textContents,
  balloonContents,
  gaEventName,
  isAnswered,
  onClickHandler: onClickHandlerFromProps,
}: OtherButtonPropsType) => {
  const [isActive, setIsActive] = React.useState<boolean>(null);
  const onClickHandler = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    // ボタンをアクティブに変更
    setIsActive(true);

    // ボタンのクリックイベントを実行
    onClickHandlerFromProps(event);
  }, [onClickHandlerFromProps]);

  return (
    <div
      css={css`
        padding: 0 0 4px;
        position: relative;
      `}
    >
      <button
        type="button"
        id={`ga_event_${gaEventName}_${id}`}
        value={value}
        onClick={onClickHandler}
        css={css`
          ${simpleButtonStyle}

          font-size: 16px;
          height: 50px;

          ${mobile(() => css`
            height: 50px;
          `)}

          ${mobile(({ clamp }) => css`
            font-size: ${clamp('14px', '16px')};
            height: ${clamp('40px', '50px')};
          `)}

          &:hover {
            ${simpleButtonHoverStyle}
          }

          ${isActive !== null && isActive && css`
            ${simpleButtonActiveStyle}
          `}

          ${isAnswered && css`
            ${simpleButtonAnsweredStyle}
          `}
        `}
      >
        {textContents}
      </button>
      {balloonContents && <Balloon balloonContents={balloonContents} />}
    </div>
  );
};
